import React from 'react';
import PropTypes from 'prop-types';
import Tabs from 'Components/ComponentLibrary/Molecules/Tabs';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import GradientSection from 'Components/ComponentLibrary/Organisms/WhatIfClientScenarioDetails/GradientSection';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import TabContent from './TabContent';

const WhatIfClientScenarioDetails = ({
  facetPlanClientViewCollection,
  facetPlanClientViewResource,
  callToAction,
  header,
  isProposalPreview,
}) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const tabs = facetPlanClientViewResource
    .attr('tabs')
    ?.resources()
    .list()
    .map(tab => ({
      key: tab.id(),
      label: tab.attr('label'),
      value: tab.id(),
    }));

  const [currentTab, setCurrentTab] = React.useState(tabs && tabs[0]?.value);

  function handleTabChange(event, value) {
    logStandardizedEvent(categories.clientWhatIf, eventTypes.navigateTo, `Scenario client details ${value} content tab`);
    setCurrentTab(value);
  }

  return (
    <VerticalStack height={'open'}>
      <StackItem background="white" contentWidth={'lg'}>
        <GradientSection
          facetPlanClientViewResource={facetPlanClientViewResource}
          header={header}
          isMultiChart={!isProposalPreview}
        />
      </StackItem>
      <StackItem position={'top'} background="white">
        <VerticalStack>
          <StackItem
            hidden={!callToAction}
            contentWidth={'lg'}
            paddingHorizontal={2}
            paddingBottom={2}
          >
            {callToAction}
          </StackItem>
          {tabs ? (
            <StackItem contentWidth={'lg'}>
              <Box paddingX={1}>
                <Tabs
                  indicatorColor="primary"
                  onChange={handleTabChange}
                  size="sm"
                  tabs={tabs}
                  textColor="black"
                  value={currentTab}
                  variant="standard"
                />
              </Box>
            </StackItem>
          ) : null}
        </VerticalStack>
      </StackItem>
      <TabContent
        currentTabId={currentTab}
        facetPlanClientViewCollection={facetPlanClientViewCollection}
        facetPlanClientViewResource={facetPlanClientViewResource}
      />
    </VerticalStack>
  );
};

WhatIfClientScenarioDetails.defaultProps = {
  header: null,
  callToAction: null,
  isProposalPreview: false,
};

WhatIfClientScenarioDetails.propTypes = {
  callToAction: PropTypes.object,
  header: PropTypes.object,
  facetPlanClientViewCollection: PropTypes.object.isRequired,
  facetPlanClientViewResource: PropTypes.object.isRequired,
  isProposalPreview: PropTypes.bool,
};

export default WhatIfClientScenarioDetails;
